<div class="li-card mb-2" [class.li-card-open]="isOpen" [class.li-card-not-acquired]="!lesson.isAcquired">

  <div class="li-header" (click)="toggleDropdown()">
    <div class="li-chevron" *ngIf="lesson.content">
      <i class="fa-solid" [class.fa-chevron-right]="!isOpen" [class.fa-chevron-down]="isOpen"></i>
    </div>
    <div class="li-chevron li-chevron-placeholder" *ngIf="!lesson.content"></div>

    <div class="li-info">
      <div class="li-name">
        <span class="li-status" [class.li-status-acquired]="lesson.isAcquired" [title]="(lesson.isAcquired ? 'Leçon acquise' : 'Leçon non acquise') | translate">
          <i class="fa-solid" [class.fa-circle-check]="lesson.isAcquired" [class.fa-circle]="!lesson.isAcquired"></i>
        </span>
        {{ lesson.name }}
      </div>
      <div class="li-meta">
        <span class="li-badge li-badge-status" [class.li-badge-acquired]="lesson.isAcquired" [class.li-badge-new]="!lesson.isAcquired">
          {{ (lesson.isAcquired ? 'Acquise' : 'À découvrir') | translate }}
        </span>
        <span class="li-badge" *ngIf="lesson.cefrl">{{ lesson.cefrl }}</span>
        <span class="li-badge li-badge-type" *ngIf="lesson.type">{{ lesson.type }}</span>
      </div>
    </div>

    <div class="li-actions" (click)="$event.stopPropagation()">
      <button type="button" class="li-action-btn" *ngIf="lesson.content" (click)="toggleDropdown()" [title]="'Aperçu' | translate">
        <i class="fa-regular fa-eye"></i>
      </button>
      <!-- TODO: téléchargement PDF désactivé temporairement
      <button type="button" class="li-action-btn" *ngIf="lesson.pdf || (!lesson.pdf && lesson.content)" (click)="download()" [title]="'Télécharger PDF' | translate">
        <i class="fa-regular fa-file-pdf"></i>
      </button>
      -->
    </div>
  </div>

  <div class="li-content" [@DropdownAnimation]="isOpen ? 'open' : 'closed'">
    <div class="li-content-inner" [innerHTML]="lesson.content | safeHtml"></div>
  </div>

</div>
